export enum BydUserServiceEnum {
  GET_USER_ENDPOINT = '/v1/users/currentuser',
}
